<template>
  <div>
    <form @submit.prevent>
      <div id="tim-kiem-thong-tin" class="">
        <b-form-group
          label=""
          label-for="keyword"
          class="border-bottom-form d-none"
        >
          <div class="d-flex">
            <div class="flex-1-0">
              <b-form-input
                v-model="requestInformation.filterBy"
                id="filterBy"
                type="text"
                required
                placeholder="Nhập tên nhóm, tên hiển thị"
                @keyup.enter="timDanhSachGroup"
              />
            </div>
            <div class="ml-2">
              <base-button button="Tìm kiếm" @click="timDanhSachGroup()" />
            </div>
          </div>
        </b-form-group>
        <div class="box-form-result">
          <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
          <DataTable
            :value="danhSachGroupNoiBo"
            :loading="isLoadingTable"
            :selection.sync="selectedGroup"
          >
            <Column
              field="id"
              headerStyle="width: 40px"
              header=""
              bodyStyle="text-align: center"
              selectionMode="multiple"
            >
            </Column>
            <Column
              field="stt"
              dataKey="stt"
              headerStyle="width: 40px"
              headerClass="p-2"
              header="STT"
              bodyStyle="text-align: center"
            >
              <template #filter> </template>
              <template #body="slotProps">
                <span>{{
                  (requestInformation.pageIndex - 1) *
                    requestInformation.pageSize +
                  slotProps.index +
                  1
                }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="name"
              header="Tên nhóm"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.Name"
                  @change="layDanhSachGroup"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.name }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="code"
              header="Mã nhóm"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.Code"
                  @change="layDanhSachGroup"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.code }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="description"
              header="Mô tả"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.Description"
                  @change="layDanhSachGroup"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.description }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="appName"
              header="Ứng dụng"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.AppName"
                  @change="layDanhSachGroup"
                />
              </template>
              <template #body="slotProps">
                <div v-html="slotProps.data.appName"></div>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="thaoTac"
              header="Thao tác"
              headerStyle="width: 100px"
            >
              <template #body="slotProps">
                <div class="text-center">
                  <b-icon
                    icon="plus-circle-fill"
                    v-b-popover.hover.top="'Thêm nhóm vào người dùng'"
                    class="cursor-pointer color-red ml-2"
                    variant="success"
                    @click="themGroup(slotProps.data.id)"
                  />
                </div>
              </template>
            </Column>
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <template #loading
              ><div class="text-center">Đang tải dữ liệu ...</div>
            </template>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestInformation.pageIndex"
            :total-pages="totalPages"
            :total-rows="totalRows"
            @changeNum="onChangeNum($event)"
            @changePages="onChangePages($event)"
          />
        </div>
        <div class="box-form-result d-flex justify-content-end mt-3">
          <base-button
            :disabled="danhSachIdGroupDaChon.length === 0"
            class="btn search-information-btn d-block mr-2"
            @click="themDanhSachGroupDaChon()"
            button="Thêm mới"
          >
            Thêm nhóm đã chọn
          </base-button>
          <base-button button="Đóng" @click="hideModal"></base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import { THEM_GROUP_VAO_NGUOI_DUNG_THANH_CONG } from "@/constants/message";

export default {
  name: "DanhSachGroupKhongThuocNguoiDung",
  components: {
    BasePagination,
  },
  data() {
    return {
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
        filterBy: "",
      },
      requestForm: {},
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      deletedId: null,
      nguoiDungId: null,
      danhSachIdGroupDaChon: [],
      danhSachIdGroup: [],
      selectAllRowsInPage: false,
      groupIds: [],
      selectedGroup: [],
    };
  },
  created() {
    this.layDanhSachGroup();
  },
  computed: {
    ...mapGetters({
      danhSachGroup: "user/danhSachGroupKhongThuocNguoiDung",
    }),
    danhSachGroupNoiBo() {
      return this.layDanhSachGroupNoiBo(this.danhSachGroup);
    },
    danhSachGroupDaChon: {
      get: function () {
        let danhSachGroup = this.danhSachGroupNoiBo.filter((quyen) =>
          this.danhSachIdGroupDaChon.includes(quyen.Id)
        );

        return danhSachGroup.items.map((quyenDaChon, index) => {
          return Object.assign({}, quyenDaChon, {}, { stt: index + 1 });
        });
      },
      set: function () {},
    },
  },
  props: {
    chiTietNguoiDung: {
      type: Object,
      required: true,
    },
    appId: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  watch: {
    selectedGroup: {
      handler() {
        this.danhSachIdGroupDaChon = (this.selectedGroup || []).map(
          (x) => x.id
        );
      },
      deep: true,
    },
    danhSachGroup: {
      handler() {
        this.danhSachIdGroup = this.layDanhSachIdGroup(this.danhSachGroupNoiBo);
        this.totalPages = this.danhSachGroup.totalPage;
        this.totalRows = _isNil(this.danhSachGroup.totalCount)
          ? 0
          : this.danhSachGroup.totalCount;
      },
    },
  },

  methods: {
    hideModal() {
      this.$bvModal.hide("them-group-nguoi-dung-modal");
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachGroup();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachGroup();
    },
    timDanhSachGroup() {
      this.layDanhSachGroup();
    },
    themGroup(id) {
      this.groupIds = [id];
      this.themGroupTheoNguoiDung();
    },
    themDanhSachGroupDaChon() {
      this.groupIds = this.danhSachIdGroupDaChon;
      this.themGroupTheoNguoiDung();
    },
    themGroupTheoNguoiDung() {
      const $vm = this;
      let payload = {
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        userId: this.chiTietNguoiDung.id,
        groupIds: this.groupIds,
        permissionIds: [],
        roleIds: [],
      };
      this.$store
        .dispatch("user/addMapping", payload)
        .then(() => {
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: THEM_GROUP_VAO_NGUOI_DUNG_THANH_CONG,
          });
          $vm.$emit("themGroupVaoNguoiDungThanhCong");
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    layDanhSachIdGroup(danhSachGroup) {
      if (_isEmpty(danhSachGroup.items)) {
        return [];
      }
      return danhSachGroup.items.map((item) => item.id);
    },
    clickSelectAllRowInPage() {
      if (this.selectAllRowsInPage) {
        this.$set(
          this,
          "danhSachIdGroupDaChon",
          this.danhSachIdGroupDaChon.concat(this.danhSachIdGroup)
        );
        this.$set(this, "danhSachIdGroupDaChon", [
          ...new Set(this.danhSachIdGroupDaChon),
        ]);
      } else {
        this.danhSachIdGroupDaChon = this.danhSachIdGroupDaChon.filter(
          (id) => !this.danhSachIdGroup.includes(id)
        );
      }
    },
    layDanhSachGroup() {
      const payload = {
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        userId: this.chiTietNguoiDung.id,
        appId: this.appId,
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("user/layDanhSachGroupKhongThuocNguoiDung", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachGroupNoiBo(danhSachGroup) {
      if (_isEmpty(danhSachGroup)) {
        return [];
      }
      return danhSachGroup.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          code: _isNil(item.code) ? "" : item.code,
          description: _isNil(item.description) ? "" : item.description,
          appName: _isNil(item.appName) ? "" : item.appName,
          id: item.id,
          thaoTac: null,
        };
      });
    },
  },
};
</script>
